import { useQuery } from '@tanstack/react-query'
import { formDataInit, defaultValuesProcessPayment } from '../utils/data'

export const setSearchFormDataKey = 'searchFormData'
export const useSearchFormData = (initialValue = initState) => {
  return useQuery({
    queryKey: [setSearchFormDataKey],
    queryFn: () => initialValue,
    initialData: initialValue, // This ensures the data is never undefined

    // Importante: esto evita llamadas al servidor
    staleTime: Infinity
  })
}

export const initState: IFormData = {
  origen: '',
  destino: '',
  date: '',
  passengers: '1'
}

interface IFormData {
  origen: string
  destino: string
  date: string
  passengers: string
}
